import { createContext } from 'react';

const WebViewContext = createContext({});

export default WebViewContext;
